import SideMenu from '@/containers/side-menu/SideMenu.vue';
import AccountMovement from '@/pages/account-movement/AccountMovement.vue';

export default {
  path: '/register-account-movements',
  name: 'AccountMovement',
  components: {
    mainContent: AccountMovement,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'register-account-movements',
    },
    breadcrumb: {
      title: 'Movimentos',
      paths: [{ title: 'Gerenciamento' }],
    },
  },
};
